import { ThemePreset } from '@form-factory/schema/enums';

export const THEME_PRESETS = {
  light: {
    preset: ThemePreset.Light,
    primary: '#e4e4e7',
    primaryFg: '#27272a',
  },
  dark: {
    preset: ThemePreset.Dark,
    primary: '#22222A',
    primaryFg: '#f4f4f5',
  },
} as const;

export const AgentDefaults = {
  name: 'Tina',
  defaultThemePreset: ThemePreset.Dark,
  defaultTheme: THEME_PRESETS.dark,
} as const;

export const DEFAULT_DOCUMENT_WEIGHT = 0.5;
